import React, { Component } from 'react';
import { Link } from "react-router-dom";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import css from './LeftNav.module.scss';

export default class LeftNav extends Component {
  state = {
  }

  render () {
      return (
        <ul className={css.leftNav}>
           <li>
             <Link to="/">Projects</Link>
           </li>
           <li>
             <Link to="/about/">About</Link>
           </li>
           <li>
             <AnchorLink href='#contact'>Contact</AnchorLink>
           </li>
        </ul>
      )
   }
}
